import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'

import { GeneralComponents } from './components'
import {
  DashboardActivities,
  DashboardComplaint,
  DashboardConsent,
  DashboardCookie,
  DashboardCrossActivities,
  DashboardDiagnostic,
  DashboardPrivacyPolicy,
  DashboardProcess,
  DashboardSupplier,
  DashboardTicket,
  DashboardTraining,
} from '..'

import usePermissions from 'hooks/usePermissions'
import permissions from 'constants/permissions'

const DashboardMain = ({
  complaintStats,
  consentStats,
  cookieStats,
  fragilityStats,
  gapStats,
  generalStats,
  isCookiesAvailable,
  privacyPolicyStats,
  processStats,
  questionControlStats,
  questionnaires,
  supplierStats,
  ticketStats,
  trainingStats,
}) => {
  const { some } = usePermissions()

  const isActivitiesPermitted = some([
    permissions.KANBAN_TASKS.LIST,
    permissions.KANBAN_TASKS.MANAGE,
    permissions.KANBAN_TASKS.DESTROY,
    permissions.KANBAN_TASKS.FINALIZE,
    permissions.KANBAN_TASKS.MANAGE_COLUMNS,
    permissions.KANBAN_TASKS.DESTROY_COMMENT,
  ])

  return (
    <>
      <GeneralComponents generalStats={generalStats} />
      <Box mt={3} width="100%" />
      <DashboardProcess processStats={processStats} />
      <Box mt={3} width="100%" />
      <DashboardDiagnostic
        gapStats={gapStats}
        questionnaires={questionnaires}
        fragilityStats={fragilityStats}
        questionControlStats={questionControlStats}
      />
      <Box mt={3} width="100%" />
      <DashboardSupplier supplierStats={supplierStats} />
      <DashboardTraining trainingStats={trainingStats} />
      <DashboardConsent consentStats={consentStats} />
      {isCookiesAvailable && <DashboardCookie cookieStats={cookieStats} />}
      <DashboardPrivacyPolicy privacyPolicyStats={privacyPolicyStats} />
      <DashboardTicket ticketStats={ticketStats} />
      <DashboardComplaint complaintStats={complaintStats} />
      {isActivitiesPermitted && (
        <>
          <Box mt={3} width="100%" />
          <DashboardActivities />
          <Box mt={3} width="100%" />
          <DashboardCrossActivities />
        </>
      )}
    </>
  )
}

DashboardMain.propTypes = {
  complaintStats: PropTypes.object.isRequired,
  consentStats: PropTypes.object.isRequired,
  cookieStats: PropTypes.array.isRequired,
  fragilityStats: PropTypes.object.isRequired,
  gapStats: PropTypes.object.isRequired,
  generalStats: PropTypes.object.isRequired,
  isCookiesAvailable: PropTypes.bool.isRequired,
  privacyPolicyStats: PropTypes.object.isRequired,
  processStats: PropTypes.object.isRequired,
  questionControlStats: PropTypes.object.isRequired,
  questionnaires: PropTypes.array.isRequired,
  supplierStats: PropTypes.object.isRequired,
  ticketStats: PropTypes.object.isRequired,
  trainingStats: PropTypes.object.isRequired,
}

export default DashboardMain
